import { render } from "./secret.vue?vue&type=template&id=4bf847c5"
import script from "./secret.vue?vue&type=script&lang=js"
export * from "./secret.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__